import React from 'react';

import About from '../components/Pages/About';

const AboutPage = ({ data: { allContentfulAboutPage: { edges } } }) => {
  return <About data={edges[0].node} />;
};

export default AboutPage;

export const EnAboutQuery = graphql`
  query EnAboutQuery {
    allContentfulAboutPage(filter: { node_locale: { eq: "en" } }) {
      edges {
        node {
          node_locale
          aboutTitle
          metaDescription
          headerImage {
            title
            sizes(quality: 100) {
              base64
              aspectRatio
              src
              srcSet
              srcWebp
              srcSetWebp
              sizes
            }
          }
          aboutQualityTitle
          childContentfulAboutPageAboutQualityContentTextNode {
            childMarkdownRemark {
              html
            }
          }
          aboutCertificationTitle
          childContentfulAboutPageAboutCertificationContentTextNode {
            childMarkdownRemark {
              html
            }
          }
          aboutCertificationImage {
            title
            sizes(quality: 100) {
              base64
              aspectRatio
              src
              srcSet
              srcWebp
              srcSetWebp
              sizes
            }
          }
          aboutToolsTitle
          childContentfulAboutPageAboutToolsContentTextNode {
            childMarkdownRemark {
              html
            }
          }
          aboutToolsYoutube
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/about.en.js